import { Product } from "./models";
import {NGXLogger} from "ngx-logger";
import {AppInjector} from "../../app.module";

export class ShoppingCart {
    private items: Product[] = [];
    products$ = this.getCartItems();
    private logger: NGXLogger;

    constructor(){
      this.logger = AppInjector.get(NGXLogger);
    };

    getCartItems() {
        return this.items;
    }

    addCartItem(product : Product) : void
    {
        this.logger.debug("Product added to shopping cart:", product.name);
        this.items.push(product);
        this.logger.debug("Number of cart items:",this.items.length);
    }

    clearCart()
    {
        this.logger.debug("Shopping cart cleared");
        this.items = [];
    }
}
